/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from "react"
import { Box, Button, Heading, Image, Text, useToast, useMediaQuery, Portal } from "@chakra-ui/react"
import { ErrorMessage } from "../../../components/commons/error.main"
import snapLogo from "../../../assets/images/SnapLogoSignup.png"
import { VerificationSuccess } from "../verificationSuccess"
import { useResendVerificationLinkMutation, useVerifyEmailMutation } from "../../../type-and-hooks"
import { chakraTheme } from "../../../theme/chakraTheme"
import { getLandscapeOrPortraitValues } from "../../../components/commons/utils"
import { ModalThreeRowLayout } from "../../../components/commons/modalThreeRowLayout"
import { useNavigate } from "react-router-dom"
import { LOCAL_STORAGE_REGISTED_EMAIL, Paths } from "../../../common/commonConstants"

export const SignUpConfirmation = (): JSX.Element => {
  const [verifyUser, { data, error }] = useVerifyEmailMutation()
  const [resendEmail, { data: resendSuccess, loading: resendLoading, error: resendError }] = useResendVerificationLinkMutation()
  const toast = useToast()
  const [isLargerThan800] = useMediaQuery("(min-width: 815px)")
  const [isLandscape] = useMediaQuery("(orientation: landscape)")

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    const token = queryParameters.get("token")
    //KP const localStorageRegisteredEmail = localStorage.getItem(LOCAL_STORAGE_REGISTED_EMAIL)
    if (token) {
      verifyUser({ variables: { token } }).catch(() => {
        // Error handled by Apollo Client
      })
      const token_user_encoded = token.split(".")[1]
      const token_user_details = JSON.parse(atob(token_user_encoded)) // decode base64
      localStorage.setItem("user-fname", token_user_details.first_name)
      localStorage.setItem("user-lname", token_user_details.last_name)
    }
  }, [])


    //if (!token && localStorageRegisteredEmail) {
      // /* token is not present, but email Id is present. This would mean that the user has not verified yet.
      //  Therefore trigger a resend mail on page load */
    /*  resendEmail({
        variables: { email_address: localStorageRegisteredEmail }
      }).catch(() => {
        // Error handled by Apollo Client
      })
    }*/

  const resendLink = (): void => {
    // temp code
    const localStorageRegisteredEmail = localStorage.getItem(LOCAL_STORAGE_REGISTED_EMAIL)
    if (localStorageRegisteredEmail) {
      resendEmail({
        variables: { email_address: localStorageRegisteredEmail }
      }).catch(() => {
        // Error handled by Apollo Client
      })
    } else {
      toast({
        title: "Error",
        description: "Invalid request - ERR01",
        status: "error"
      })
    }
  }

  useEffect(() => {
    if (resendSuccess) {
      toast({
        title: "Email sent successfully",
        description: "Please check your email for the verification link",
        status: "success"
      })
    }
  }, [resendSuccess, toast])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if (resendError?.graphQLErrors.length || resendError?.message) {
      toast({
        title: "Error",
        description: (resendError.graphQLErrors[0] as unknown as string) ?? `Resend Error: ${resendError?.message}`,
        status: "error"
      })
    }
  }, [resendError, toast])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if (!error) {
      return
    }

    if (error?.graphQLErrors.length || error?.message) {
      toast({
        title: "Error",
        description: (error.graphQLErrors[0] as unknown as string) ?? `Verification Error ${error?.message}`,
        status: "error"
      })
    }
  }, [error, toast])
  const navigate = useNavigate()

  return (
    <Box pos="fixed" top="0" w="100vw" height="100vh" zIndex="900">
      {error && (
        <Box w="100%" h="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" bg="primary" color="white">
          <Image src={snapLogo} h={["125px", "125px", "125px", "262px", "262px", "262px"]} bottom={"0px"} />
          <ErrorMessage
            styles={{ color: "white", ...chakraTheme.components.Heading.variants.Heading1SemiBold }}
            error={`Error: ${error.graphQLErrors[0].toString() ?? "Something went wrong"}.`}
            primaryAction
            buttonStyles={{ bg: "white", color: "primary" }}
            primaryActionText="Login"
            primaryActionCallBack={() => {
              navigate(Paths.LOGIN.login)
            }}
          />
        </Box>
      )}
      {data && !error && <VerificationSuccess />}
      {!data && !error && (
        <ModalThreeRowLayout
          middleComponent={
            <Box gridRowStart={2} gridRowEnd={3} gridColumnStart={2} gridColumnEnd={3}>
              <Heading color="white" variant={"Heading1"} textAlign={"center"}>
                Thanks for signing up with us.
              </Heading>
              <Text
                variant="RBody"
                color="white"
                textAlign={"center"}
                px="4"
                mt={getLandscapeOrPortraitValues("4", "2", !isLargerThan800 && isLandscape)}
              >
                We&apos;ve sent a verification link to the email you added. Please click the link to complete your registration.{" "}
                <Text>This may take a few minutes.</Text>
              </Text>
            </Box>
          }
          footerComponent={
            <Box gridRowStart={3} gridRowEnd={4} gridColumnStart={2} gridColumnEnd={3}>
              <Box textAlign={"center"}>
                <Text mb={[4, 4, 4, 8, 8, 8]} variant="RBody" color="white">
                  If you&apos;re having trouble receiving the link, click the button below:
                </Text>
                <Button
                  variant="Button1RegularOutline"
                  px="18px"
                  py="6px"
                  onClick={() => {
                    resendLink()
                  }}
                  isLoading={resendLoading}
                >
                  Resend Link
                </Button>
              </Box>
            </Box>
          }
        />
      )}
    </Box>
  )
}
